import { Avatar, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { AppColors } from '../../../Utils/helper/AppColors';
import { MdOutlinePlayCircleOutline } from 'react-icons/md';
import moment from 'moment';
import PlayingModal from './PlayingModal';
import { DotIcon, InfoOutlineIcon, PlayCircleIcon } from '../../../Components/Icons/Icons';
import CultService from '../../../Services/CultService';
import { useSelector } from 'react-redux';
import UserThumbnail from '../../../Components/User/UserThumbnail';
import NotesColumn from './NotesColumn';
import { USER_TYPE } from '../../../Utils/helper/AppConstants';
import CustomTablePagination from '../../../Components/CustomTablePagination';
import DepartmentTag from '../../../Components/DepartmentTag';
import ViewNotes from '../../../Components/ViewNotes';
import CustomTag from '../../../Components/CustomTag';
import recordIcon from '../../../Assets/Icons/record.svg';
import DataNotFound from '../../../Components/DataNotFound';
import { theme } from 'antd';

export default function CallRecordingsList({
	recordings,
	chageIconText = false,
	height,
	fetch,
	hideUser,
	pagination,
	noPagination,
}) {
	const [selected, setSelected] = useState(null);
	const user = useSelector((state) => state.app.user);
	// console.log("pagination data ; ",pagination)
	const getScoreColor = (score) => {
		let res = AppColors.STATUS_GREY;
		if (score < 40) {
			res = AppColors.tomato_orange || AppColors.STATUS_RED;
		}
		if (score >= 40 && score <= 70) {
			res = AppColors.yellow || AppColors.STATUS_YELLOW;
		}
		if (score > 70) {
			res = AppColors.green || AppColors.STATUS_GREEN;
		}
		return res;
	};

	const handleAddComment = async ({ payload, onComplete }) => {
		payload = { ...payload, userId: user?._id };
		let res = await CultService.addComment({ data: payload });
		if (res.status == 200) {
			fetch();
			if (typeof onComplete == 'function') {
				onComplete();
			}
		}
	};

	console.log('recordings--', recordings);


    // const filteredUnAnonymousRecordings = recordings;
	const filteredUnAnonymousRecordings = recordings?.filter((recording ) => recording?.anonymous !== true);


   return (
      
		<>
			<TableContainer sx={{ minHeight: height, maxHeight: height, backgroundColor: AppColors.WHITE, borderRadius: '10' }}>
				{filteredUnAnonymousRecordings?.length === 0 ? (
					
					<DataNotFound />
				) : (
					<Table stickyHeader>
						<TableHead
							sx={{
								'& .MuiTableCell-root': {
									fontSize: 14,
									color: AppColors?.midnight_black || AppColors.BLACK,
									fontWeight: 400,
									fontFamily: 'Poppins',
									lineHeight: '150%',
								},
							}}
						>
							{!hideUser && <TableCell width={180}>Employee</TableCell>}
							<TableCell width="40%">Summary</TableCell>
							<TableCell />
							{!hideUser && <TableCell>Department</TableCell>}
							<TableCell>Date</TableCell>
							<TableCell>Recording</TableCell>
							<TableCell>Notes</TableCell>
						</TableHead>
						<TableBody>
							{filteredUnAnonymousRecordings?.map((c, index) => (
								<TableRow sx={{ '& .MuiTableCell-root': { verticalAlign: 'top' } }}>
									{!hideUser && (
										<TableCell>
											<UserThumbnail user={{ firstName: c.name }} userId={c?.userId} />
										</TableCell>
									)}
									<TableCell>
										<Typography
											sx={{
												fontSize: 14,
												color: AppColors.HEADING_TITLE4,
												fontWeight: 400,
												fontFamily: 'Poppins',
												lineHeight: '150%',
											}}
										>
											{c?.callSummary?.summary}
										</Typography>
									</TableCell>

									<TableCell>
										<Stack direction="row" alignItems="center" gap={0.5}>
											{c?.hasHarassmentTendencies && <InfoOutlineIcon color={AppColors.tomato_orange || AppColors.STATUS_HARASSMENT} />}
											{c?.hasSuicidalTendencies && <InfoOutlineIcon color={AppColors.yellow || AppColors.STATUS_SUICIDAL} />}

											{!c?.hasHarassmentTendencies && !c?.hasSuicidalTendencies && (
												<DotIcon size={18} color={getScoreColor(c.callSummary?.score)} />
											)}
										</Stack>
									</TableCell>

									{!hideUser && (
										<TableCell>
											<Typography sx={{ textTransform: 'capitalize' }} variant="subtitle2">
												{c?.department && <CustomTag tagTitle={c?.department?.toLowerCase()} 												colorsInfo={{ "color": AppColors.midnight_black, "bgColor": AppColors.lightest_grey, "border": AppColors.light_grey }} />}
											</Typography>
										</TableCell>
									)}

									<TableCell>
										<Typography
											sx={{
												fontSize: 14,
												color: AppColors.HEADING_TITLE4,
												fontWeight: 600,
												fontFamily: 'Poppins',
												lineHeight: '150%',
											}}
										>
											{moment(c?.call?.startedAt).format('MM-DD-YYYY')}
										</Typography>
									</TableCell>

									<TableCell>
										<Stack
											sx={{
												pointerEvents: c?.name === USER_TYPE.ANONYMOUS ? 'none' : 'auto',
												opacity: c?.name === USER_TYPE.ANONYMOUS ? 0.2 : 1,
											}}
											direction="row"
											alignItems="center"
											gap={0.5}
										>
											{/* <Avatar
												sx={theme => ({ height: 30, width: 30, color: theme.palette.primary.primary_shade, borderRadius: 0, cursor: 'pointer' })}
												src={recordIcon}
												onClick={() => setSelected(c)}
											/> */}
											<PlayCircleIcon color={AppColors?.tomato_orange} size={28} onClick={() => setSelected(c)}  />

											<Typography variant="subtitle1" sx={theme => ({ color: theme.palette.primary.darker_primary })} fontSize={12}>
												Recording {index + 1}
											</Typography>
										</Stack>
									</TableCell>

									<TableCell>
										{(c?.userId || c?.name !== 'anonymous') && (
											<Stack gap={1} direction="row" alignItems="center">
												<NotesColumn
													firstIcon={chageIconText}
													id={c._id}
													handleAddComment={handleAddComment}
													comments={c?.comments}
													campaign={c?.campaign?.basicDetails}
												/>
												<ViewNotes comments={c?.comments} campaign={c?.campaign?.basicDetails} />
											</Stack>
										)}
									</TableCell>
								</TableRow>
							))}

							<TableRow
								sx={{
									position: 'sticky',
									bottom: 0,
									backgroundColor: '#fff',
									paddingY: '8px',
									zIndex: 2, // Ensure it's above other rows
									// width:'10%'
								}}
							>
								{!noPagination && (
									<TableCell sx={{ py: '4px' }} colSpan={12} align="center">
										<CustomTablePagination
											{...pagination}
											onChange={(p, r) => fetch(p, r)}
											onRowsPerPageChange={(e) => fetch(1, e.target.value)}
										/>
									</TableCell>
								)}
							</TableRow>
						</TableBody>
					</Table>
				)}
			</TableContainer>

			{/* {!noPagination && (
				<CustomTablePagination
					{...pagination}
					onChange={(p, r) => fetch(p, r)}
					onRowsPerPageChange={(e) => fetch(1, e.target.value)}
				/>
			)} */}
			<PlayingModal open={Boolean(selected)} onClose={() => setSelected(null)} selected={selected} />
		</>
	);
}
